import { AdminOnlyRoute } from 'components/utils/AdminOnlyRoute';
import PageWrapper from 'components/utils/PageWrapper';
import AdminExpressJobs from 'pages/AdminExpressJobs';

export const adminRoutes = {
    element: <AdminOnlyRoute />,
    children: [
        {
            path: '/admin-express-jobs',
            element: (
                <PageWrapper titleId="admin_express_jobs_title">
                    <AdminExpressJobs />
                </PageWrapper>
            ),
        },
    ],
};
